import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import {
  TrendingUp as TrendingUpIcon,
  People as PeopleIcon,
  CheckCircle as CheckCircleIcon,
  AttachMoney as AttachMoneyIcon,
} from '@mui/icons-material';
import { ReportStats } from '../../types/reports.types';

interface StatsCardsProps {
  stats: ReportStats;
}

export const StatsCards: React.FC<StatsCardsProps> = ({ stats }) => {
  const cards = [
    {
      title: 'Total Leads',
      value: stats.totalLeads,
      icon: <PeopleIcon sx={{ fontSize: 40 }} />,
      color: '#3b82f6',
    },
    {
      title: 'Conversion Rate',
      value: `${stats.conversionRate.toFixed(1)}%`,
      icon: <TrendingUpIcon sx={{ fontSize: 40 }} />,
      color: '#10b981',
    },
    {
      title: 'Won Leads',
      value: stats.wonLeads,
      icon: <CheckCircleIcon sx={{ fontSize: 40 }} />,
      color: '#8b5cf6',
    },
    {
      title: 'Total Value',
      value: `$${(stats.totalValue / 1000).toFixed(1)}K`,
      icon: <AttachMoneyIcon sx={{ fontSize: 40 }} />,
      color: '#f59e0b',
    },
  ];

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, gap: 3, mb: 3 }}>
      {cards.map((card, index) => (
        <Box key={index}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
                <Box>
                  <Typography variant='body2' color='text.secondary' gutterBottom>
                    {card.title}
                  </Typography>
                  <Typography variant='h4' component='div'>
                    {card.value}
                  </Typography>
                </Box>
                <Box sx={{ color: card.color }}>
                  {card.icon}
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Box>
      ))}
    </Box>
  );
};